import React, { useState } from "react";
import RoleToggle from "../../components/RoleToggle";
import CountryListTab from "./_components/CountryListTab";
import HubsListTab from "./_components/HubsListTab";
import CitiesListTab from "./_components/CitiesListTab";

const Location: React.FC = () => {
  const [activeRole, setActiveRole] = useState("Country");
  const roles = ["Country",  "Cities"];


  return (
    <div className="p-4 space-y-4">
      <h1 className="text-3xl text-[#212121]">Location</h1>
      <RoleToggle
        options={roles}
        active={activeRole}
        onChange={setActiveRole}
      />
      <div className="">
        {activeRole === "Country" && <CountryListTab  />}
        {/* {activeRole === "Hub" && <HubsListTab />} */}
        {activeRole === "Cities" && <CitiesListTab />}
      </div>
    </div>
  );
};

export default Location;
